//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      // 回调函数使用
      className: '',
      // 更新数值用
      end: 50
    };
  },
  methods: {
    update: function update() {
      var _this = this;

      setTimeout(function () {
        _this.end = 100;
      }, 1000);
    }
  }
};